import request from '@/utils/request'

/**
 * 获取公共配置信息
 * @param {string} configKey 配置键
 * @returns {Promise}
 */
export function getPublicConfig(configKey) {
    return request({
        url: `/shop/settings/public/${configKey}`,
        method: 'get'
    })
}
